export const COUNT = {
  TrendingNews: 30,
  PolicyAction: 30,
};
